<script setup></script>

<template>
  <svg :class="$style.spinner" width="1em" height="1em" viewBox="0 0 50 50">
    <circle
      :class="$style.path"
      cx="25"
      cy="25"
      r="20"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="7"
      fill="none"
    />
  </svg>
</template>

<style module>
.spinner {
  animation: rotate 2s linear infinite;
}

.path {
  animation: dash 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 70, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
